import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnlinkCustomerCateringUserFromStoreMutationVariables = Types.Exact<{
  user_uuids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type UnlinkCustomerCateringUserFromStoreMutation = { __typename?: 'Mutation', unlinkCustomerCateringUserFromStore: boolean };


export const UnlinkCustomerCateringUserFromStoreDocument = gql`
    mutation UnlinkCustomerCateringUserFromStore($user_uuids: [ID!]!) {
  unlinkCustomerCateringUserFromStore(user_uuids: $user_uuids)
}
    `;
export type UnlinkCustomerCateringUserFromStoreMutationFn = Apollo.MutationFunction<UnlinkCustomerCateringUserFromStoreMutation, UnlinkCustomerCateringUserFromStoreMutationVariables>;

/**
 * __useUnlinkCustomerCateringUserFromStoreMutation__
 *
 * To run a mutation, you first call `useUnlinkCustomerCateringUserFromStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCustomerCateringUserFromStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCustomerCateringUserFromStoreMutation, { data, loading, error }] = useUnlinkCustomerCateringUserFromStoreMutation({
 *   variables: {
 *      user_uuids: // value for 'user_uuids'
 *   },
 * });
 */
export function useUnlinkCustomerCateringUserFromStoreMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkCustomerCateringUserFromStoreMutation, UnlinkCustomerCateringUserFromStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkCustomerCateringUserFromStoreMutation, UnlinkCustomerCateringUserFromStoreMutationVariables>(UnlinkCustomerCateringUserFromStoreDocument, options);
      }
export type UnlinkCustomerCateringUserFromStoreMutationHookResult = ReturnType<typeof useUnlinkCustomerCateringUserFromStoreMutation>;
export type UnlinkCustomerCateringUserFromStoreMutationResult = Apollo.MutationResult<UnlinkCustomerCateringUserFromStoreMutation>;
export type UnlinkCustomerCateringUserFromStoreMutationOptions = Apollo.BaseMutationOptions<UnlinkCustomerCateringUserFromStoreMutation, UnlinkCustomerCateringUserFromStoreMutationVariables>;